import { render, staticRenderFns } from "./Active.vue?vue&type=template&id=62dd1d1e&scoped=true&"
import script from "./Active.vue?vue&type=script&lang=js&"
export * from "./Active.vue?vue&type=script&lang=js&"
import style0 from "./Active.vue?vue&type=style&index=0&id=62dd1d1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd1d1e",
  null
  
)

export default component.exports